export default __webpack_public_path__ + "static/media/ctntarjeta.f273e7f5.jpg";